export default __webpack_public_path__ + "static/media/company-profile-bg.a11948b1.jpg";